import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import Button from '../../components/Button/Button';
import ContentPage from '../../components/Section/ContentPage';
import DynamicMessage from './DynamicMessage';
import Icon from '../../assets/images/icon-1.png';

const useStyles = makeStyles(
  (theme) => ({
    description: {
      fontSize: theme.typography.$fzH4,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.67',
      letterSpacing: 'normal',
      '@media (max-width: 767px)': {
        fontSize: theme.typography.$fzH6,
        '& br': {
          display: 'none',
        },
      },
    },
    mb40: {
      marginBottom: '40px',
    },
    buttonWrapper: {
      display: 'flex',
      alignItems: 'center',
      '@media (max-width: 767px)': {
        display: 'block',
      },
    },
    buttonSecondary: {
      marginLeft: '20px',
      '@media (max-width: 767px)': {
        width: '100%',
        marginTop: '20px',
        marginLeft: '0px',
        button: {
          width: '100%',
        },
      },
    },
  }),
);

const AccessSetupMsg = (props) => {
  const {
    dynamicContent, hasInbButton, hasOsplButton, hasIcon
  } = props;
  const classes = useStyles();
  const firstButtonClass = classes.buttonWrapper;
  let secondButtonClass = classes.buttonSecondary;
  if (!hasOsplButton && hasInbButton) {
    secondButtonClass = firstButtonClass;
  }
  return (
    <ContentPage
      srcImage={hasIcon && Icon}
      title={dynamicContent && dynamicContent.TITLE}
      content={(
        <>
          <DynamicMessage text={dynamicContent && dynamicContent.CONTENT_TEXT} classes={classes} />
          <div className={firstButtonClass}>
            {hasOsplButton && (
              <Button
                backgroundClass="bgLipstickOrangey"
                fullWidthMobile
                onClick={() => console.log('aaaa')}
              >
                Online Trading
              </Button>
            )}
            <div className={clsx(secondButtonClass)}>
              {hasInbButton && (
                <Button
                  backgroundClass="bgClearblue"
                  fullWidthMobile
                  hasHref
                  href="https://internet.ocbc.com/internet-banking/Login/Login"
                  target=""
                >
                  Digital Banking
                </Button>
              )}
            </div>
          </div>
        </>
      )}
    />
  );
};

export default AccessSetupMsg;